



























































































































































































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import WaveSurfer from "wavesurfer.js";
import {uuid} from 'vue-uuid'

const dialog = namespace('dialog')
const forms = namespace('forms')
const profile = namespace('profile')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
  },
  name: "AddComentForm"
})
export default class AddComentForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options: any
  @profile.Mutation('changeContacts') protected changeContacts: any

  contactCategory: any = ''
  contactCategoryList: any = [
    {title: this.$t('profile.contacts.phone'), value: 'phone'},
    {title: this.$t('profile.contacts.email'), value: 'email'},
    {title: this.$t('profile.company.site'), value: 'site'},
    {title: this.$t('profile.address.title'), value: 'address', subtitle: this.$t('profile.address.subtitle')},
    // {title: this.$t('profile.company.social'), value: 'network'}
  ]
  networkCategoryList: any = [
    {title: 'Facebook', value: 'facebook'},
    {title: 'Instagram', value: 'instagram'},
    {title: 'YouTube', value: 'youtube'},
    {title: 'Twitter', value: 'twitter'},
    {title: 'VK', value: 'vk'},
    {title: 'WhatsApp', value: 'whatsapp'},
    {title: 'Telegram', value: 'telegram'},
    {title: 'Viber', value: 'viber'}
  ]
  network: any = {
    value: '',
    type: ''
  }
  address: any = {
    title: '',
    subtitle: '',
    address: '',
    city: '',
    region: '',
    _country: 'RU',
    postcode: ''
  }
  title: string = ''
  phone: string = ''
  email: string = ''
  site: string = ''
  isValidBtn: boolean = false


  get countries() {
    return this.$store.getters['resources/getCountries']
  }

  @Watch('fullDialogShow')
  resetAddContactForm() {
    this.contactCategory = ''
    this.title = ''
    this.phone = ''
    this.email = ''
    this.site = ''
    this.isValidBtn = false
    this.address = {
      title: '',
      subtitle: '',
      address: '',
      city: '',
      region: '',
      _country: 'RU',
      postcode: ''
    }
    this.network = {
      value: '',
      type: ''
    }
  }

  save() {
    let contacts: any[] = []
    let contact: any = {}
    if (this.contactCategory === 'network') {
      contact = {
        title: this.title,
        type: this.network.type,
        value: this.network.value
      }
    } else if (this.contactCategory === 'address') {
      contact = {
        ...this.address,
        title: this.address.title,
        type: 'address'
      }
    } else {
      contact = {
        title: this.title,
        type: this.contactCategory,
        value: this[(this.contactCategory as keyof AddComentForm)]
      }
    }

    let id = uuid.v1()
    contact.id = id
    if (contact.type === 'address') {
      contacts = [...this.options.badge.locations, contact]
    } else {
      contacts = [...this.options.badge.contacts, contact]
    }


    if (contact.type === 'address') {
      let payload = {
        id: this.options.badge._id,
        contacts: this.options.badge.contacts,
        promo: this.options.badge.promo,
        locations: contacts,
        isCurrentCompany: this.options.isCurrentCompany
      }
      this.changeContacts(payload)
    } else {
      let payload = {
        id: this.options.badge._id,
        contacts: contacts,
        promo: this.options.badge.promo,
        locations: this.options.badge.locations,
        isCurrentCompany: this.options.isCurrentCompany
      }
      this.changeContacts(payload)
    }

    this.SetFullDialogShow(false)
  }

  setTitle(value: string) {
    this.isValidBtn = false

    const category: any = this.contactCategoryList.find((cat: any) => cat.value === value)
    if (category) {
      if (category.value === 'address') {
        this.title = this.address.title = category.subtitle
      } else {
        this.title = category.title
      }
      if (category.value !== 'address') {
        this.address = {
          title: '',
          subtitle: '',
          address: '',
          city: '',
          region: '',
          _country: 'RU',
          postcode: ''
        }
      }
      if (category.value !== 'network') {
        this.network = {
          value: '',
          type: ''
        }
      }
      if (category.value !== 'phone') {
        this.phone = ''
      }
      if (category.value !== 'email') {
        this.email = ''
      }
      if (category.value !== 'site') {
        this.site = ''
      }
    }
  }

  changeContact() {
    if (this.contactCategory == 'address') {
      this.isValidBtn = this.address.title.length != 0 && this.address.address.length != 0 && this.address.city.length != 0
    } else if (this.contactCategory == 'network') {
      this.isValidBtn = this.title.length != 0 && this.network.value.length != 0 && this.network.type.length != 0
    } else if (this.contactCategory == 'phone') {
      this.isValidBtn = this.title.length != 0 && this.phone.length != 0
    } else if (this.contactCategory == 'email') {
      this.isValidBtn = this.title.length != 0 && this.email.length != 0
    } else if (this.contactCategory == 'site') {
      this.isValidBtn = this.title.length != 0 && this.site.length != 0
    }
  }

}
